// extracted by mini-css-extract-plugin
export default {"payPeriod-header":"Header_payPeriod-header__CCHRK","payPeriod-header-item":"Header_payPeriod-header-item__i3eYf"};